import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import TipoProdutoService from '../../../app/service/tipoProdutoService'
import * as popUp from '../../toastr'
import HandleErrorService from '../../../app/service/handleErrorService'
import GeneralServices from '../../../app/service/generalServices'
import CustomHighlighter from '../../customHighlighter'
import TooltipButton from '../../tooltipButton'
import CreateOrUpdateTipoProdutoDialog from './createOrUpdateTipoProdutoDialog'
import ConstantsUtil from '../../../context/constantsUtil'
import TipoEstoqueService from '../../../app/service/tipoEstoqueService'
import ConfirmationDialog from '../../confirmationDialog'
import CadastroProdutoService from '../../../app/service/central/cadastroProdutoService'

class TipoProdutoTable extends React.Component {

    constructor(){
        super()
        this.tipoProdutoService = new TipoProdutoService()
        this.tipoEstoqueService = new TipoEstoqueService()
        this.cadastroProdutoService = new CadastroProdutoService()
    }

    state = {
        list: [],
        filteredList: [],
        selectedItem: {},
        
        tipoProdutoToEdit: '',
        displayEditDialog: false,
        
        tipoProdutoToDelete: '',
        displayDeleteDialog: false,
        
        forceUpdate: false,
        loading: false,

    }


    componentDidMount(){
        this.search()
    }

    search = () => {
        this.setState({loading: true})
        this.handleSearch()
        .then(response => {
            this.setState({list: response.data})
            this.setState({filteredList: response.data})
        })
        .catch(error => {
            HandleErrorService.handleChange(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    handleSearch = () => {
        switch(this.props.tipo){
            
            case ConstantsUtil.inputTipoProduto:
                return this.tipoProdutoService.search()
            
            case ConstantsUtil.inputTipoEstoque:
                return this.tipoEstoqueService.search()
        }
    }

    filter  = () => {
        
        this.setState({
            filteredList:
                JSON.parse(
                    JSON.stringify(
                        this.state.list.filter(tipoProduto => {
                            return(
                                GeneralServices.includeString(tipoProduto.descricao, this.props.searchText)
                            )
                        }
                        )
                    )
                )
        })
    }

    edit = async (tipoProduto) => {
        // console.log("edit tipoProduto: ", tipoProduto)
        await this.setState({tipoProdutoToEdit: JSON.parse(JSON.stringify(tipoProduto))})
        await this.setState({forceUpdate: true})
        this.setState({displayEditDialog: true})
    }

    delete = async (tipoProduto) => {
        // console.log("edit tipoProduto: ", tipoProduto)
        await this.setState({tipoProdutoToDelete: JSON.parse(JSON.stringify(tipoProduto))})
        await this.setState({forceUpdate: true})
        this.setState({displayDeleteDialog: true})
    }

    doneForceUpdate = () => {
        this.setState({forceUpdate: false})
    }

    isEditDialogOpen = () => {
        return this.state.displayEditDialog
    }

    isDeleteDialogOpen = () => {
        return this.state.displayDeleteDialog
    }

    hideDialogs = () => {
        this.setState({
            displayEditDialog: false,
            tipoProdutoToEdit: '',
            displayDeleteDialog: false,
            tipoProdutoToDelete: '',
        })
    }

    handleSelectionChange = (event) => {
        this.setState({selectedItem: event.value})
        this.props.handleSelectionChange(event.value)
    }

    handleDelete = () => {

        /*
            O tipoProduto do state na verdade pode ser:
            - Tipo de Produto
            - Tipo de Estoque
        */

        switch(this.props.tipo){
            
            case ConstantsUtil.inputTipoProduto:
                return this.cadastroProdutoService.deleteTipoProduto(this.state.tipoProdutoToDelete.id)
            
            case ConstantsUtil.inputTipoEstoque:
                return this.cadastroProdutoService.deleteTipoEstoque(this.state.tipoProdutoToDelete.id)
        }
    }

    confirmDelete = () => {
        this.handleDelete()
        .then(response => {
            this.hideDialogs()
            popUp.successPopUp("Deletado com sucesso!")
            this.search()
        })
        .catch(error => 
            HandleErrorService.handleError(error)
        )
    }

    render() {

        const renderConfimationDeleteDialog = () => {
            return (
                <ConfirmationDialog
                    visible={this.state.displayDeleteDialog}
                    header={`Deletar ${this.state.tipoProdutoToDelete.descricao}`} //Tratar entre tipoProduto e tipoEstoque
                    confimationMessage={ "Deseja Confirmar?"}
                    confirm={this.confirmDelete}
                    hide={this.hideDialogs}
                    width={'30%'}
                />                  
            )
        }

        const renderTipoDreCompetenciaColumn = () => {
            if(this.props.tipo === ConstantsUtil.inputTipoProduto){
                return(
                    <Column field="tipoDreCompetencia.descricao" header="Tipo DRE Competência" sortable
                    />                    
                )
            }
        }

        const actionBody = (selectedTipoDeProduto) => {
            // if(!selectedTipoDeProduto.fixoSistema)
            return (
                <React.Fragment>
                    <TooltipButton
                        tooltip = "Editar Tipo de Produto"
                        icon={<i className="pi pi-pencil" style={{fontSize: '1em'}}></i>}
                        onClick={() => this.edit(selectedTipoDeProduto)}
                        style={ {maxHeight: '25px', maxWidth: '25px'} }
                    />
                    <TooltipButton
                        tooltip = "Excluir Tipo de Produto"
                        className="p-button-danger right-button"
                        icon={<i className="pi pi-trash" style={{fontSize: '1em'}}></i>}
                        onClick={() => this.delete(selectedTipoDeProduto)}
                        style={ {maxHeight: '25px', maxWidth: '25px'} }
                    />
                </React.Fragment>
            );
        }

        return (
            <div className="">
            <div className="card">

                <DataTable
                    // ref={this.dt}
                    value={this.state.filteredList}
                    className="p-datatable-sm small-font"
                    rowHover
                    emptyMessage="Não há nenhum cadastrado"
                    selection={this.state.selectedItem}
                    onSelectionChange={this.handleSelectionChange}
                    // scrollable
                    // scrollHeight="500px"
                    loading={this.state.loading}
                    dataKey="id"
                    // paginator rows={25} rowsPerPageOptions={[5, 10, 25]}
                    // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    // currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} contas bancárias"
                >

                    <Column selectionMode="single" headerStyle={{ width: '3rem' }} />

                    <Column field="descricao" header="Descrição" sortable
                        body={rowData => 
                            <CustomHighlighter
                                searchWords={[this.props.searchText]}
                                textToHighlight={rowData.descricao}
                            />
                        }                    
                    />

                    <Column field="fixoSistema" header="Fixo do Sistema" sortable
                        body={rowData => rowData.fixoSistema ? 'Sim' : 'Não'}
                    />

                    {renderTipoDreCompetenciaColumn()}

                    <Column header="Ações" body={actionBody} style ={ {width: '140px'} }
                    />

                </DataTable>
            </div>

            <CreateOrUpdateTipoProdutoDialog
                visible={this.state.displayEditDialog}
                tipo={this.props.tipo}
                isEdit
                hideDialog={this.hideDialogs}
                tipoDeProduto={this.state.tipoProdutoToEdit}
                search={this.search}
                forceUpdate={this.state.forceUpdate}
                doneForceUpdate={this.doneForceUpdate}
            />

            {renderConfimationDeleteDialog()}

            </div>
        )
    }
}

export default TipoProdutoTable